import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radio", "option"];

  connect() {
    this.#updateVisualState();
  }

  select(event) {
    const value = event.params.value;
    this.radioTargets.forEach((radio) => {
      radio.checked = radio.value === value;
    });
    this.#updateVisualState();
  }

  #updateVisualState() {
    const selected = this.radioTargets.find((r) => r.checked);

    this.optionTargets.forEach((option) => {
      const value = option.dataset.value;
      const isSelected = selected && selected.value === value;

      // Reset all dynamic classes
      option.classList.remove(
        "border-success",
        "bg-success",
        "text-success-content",
        "border-error",
        "bg-error",
        "text-error-content",
        "border-base-300",
        "opacity-40"
      );

      if (selected) {
        if (isSelected) {
          if (value === "approved") {
            option.classList.add(
              "border-success",
              "bg-success",
              "text-success-content"
            );
          } else {
            option.classList.add(
              "border-error",
              "bg-error",
              "text-error-content"
            );
          }
        } else {
          option.classList.add("border-base-300", "opacity-40");
        }
      } else {
        option.classList.add("border-base-300");
      }
    });

    // Toggle filled/outline icons
    this.optionTargets.forEach((option) => {
      const value = option.dataset.value;
      const isSelected = selected && selected.value === value;
      option.querySelectorAll("i[data-icon]").forEach((icon) => {
        const base = icon.dataset.icon;
        icon.className = icon.className.replace(
          new RegExp(`i-ph-${base}(-fill)?\\b`),
          isSelected ? `i-ph-${base}-fill` : `i-ph-${base}`
        );
      });
    });
  }
}
